<template>
  <VModal :showing="showing" container-classes="max-w-screen-md" @update:showing="$emit('update:showing', $event)">
    <h2 class="text-xl mb-8 mr-8 truncate">Warning! This 3D Presentation is being used for an embed.</h2>
    <div class="text-gray-800 font-light">
      <p>This 3D Presentation cannot be deleted because it is currently being used for the following 3D Presentation embeds:</p>
      <ul class="ml-4">
        <li v-for="embed in deckEmbeds.slice(0, 5)" :key="embed.id">{{ embed.name }}</li>
      </ul>
      <p v-if="deckEmbeds.length > 5" class="font-italic ml-4">&hellip;{{ deckEmbeds.length - 5 }} more&hellip;</p>
      <p>To delete this 3D Presentation, please use a different 3D Presentation for the embeds listed above.</p>
    </div>
    <div class="flex flex-row gap-4 mt-8 w-full justify-end">
      <VButton class="w-42" variant="copper" data-testid="cancel-button" @click="$emit('update:showing', false)">OK</VButton>
    </div>
  </VModal>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { DeckEmbed } from '@/entities/embed'

defineProps({
  showing: {
    type: Boolean,
    default: false,
  },
  deckEmbeds: {
    type: Array as PropType<DeckEmbed[]>,
    default: () => [],
  },
})

defineEmits(['delete-deck', 'update:showing'])
</script>
